import script from "./Locations.vue?vue&type=script&setup=true&lang=js"
export * from "./Locations.vue?vue&type=script&setup=true&lang=js"

import "./Locations.vue?vue&type=style&index=0&id=50685d3e&lang=css"

const __exports__ = script;

export default __exports__